import React, { useState, useEffect, useContext } from "react";
import { NavLink, useParams } from "react-router-dom";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import AccountSiderBar from "./AccountSideBar";
import { useTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import QRCode from 'qrcode';
import { jsPDF } from "jspdf";
import 'jspdf-autotable';
import Invoice from "../../Components/Invoice/Invoice";
import * as htmlToImage from 'html-to-image';
import { OverlayLoader } from "../../Components/Shimmers";
import { axiosGet } from "../../Apis/axiosMethods";

const OrderPrintDownload = () => {

  const { token, lang, apiB2BURL, currency } = useContext(ConfigContext);
  const { order_uid } = useParams();
  const [orderInfo, setOrderInfo] = useState([]);
  const [address, setAddress] = useState([]);
  const [details, setDetails] = useState([]);
  const [returnData, setReturnData] = useState([]);
  const [cancelData, setCancelData] = useState([]);
  const [items, setItems] = useState([]);
  const { t } = useTranslation();
  const dir = localStorage.getItem('dir');
  const [qrCodeURL, setQrCodeURL] = useState('');

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    QRCode.toDataURL('https://ghayar.com')
      .then(url => {
        setQrCodeURL(url);
      })
      .catch(err => {
        console.error(err)
      })

  }, [])

  useEffect(() => {
    OrderInfo();
  }, [])

  const OrderInfo = async () => {
    try {
      setLoading(true);

      const response = await axiosGet(`/Orders/GetCurrencyConversionOrdersDetails`,
        {
          lang,
          secret_order_id: order_uid,
          currency
        });

      setOrderInfo(response?.data?.data);
      setDetails(response?.data?.data);
      setItems(response?.data?.items);
      setAddress(response?.data?.address);
      setReturnData(response?.data?.return_data || []);
      setCancelData(response?.data?.cancel_data || []);

    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const downloadInvoice = () => {
    const invoiceElement = document.getElementById('myInvoice');
    const computedStyle = window.getComputedStyle(invoiceElement);
    const actualHeight = invoiceElement.offsetHeight;

    const options = {
      scale: 2,
      height: actualHeight,
      style: {
        transform: 'scale(1)',
        transformOrigin: 'top left',
        padding: computedStyle.padding,
        backgroundColor: 'white',
      },
      quality: 1.0,
      cacheBust: true
    };

    htmlToImage.toPng(invoiceElement, options)
      .then(async (dataUrl) => {
        const pdf = new jsPDF({
          orientation: 'p',
          unit: 'pt',
          format: 'a4',
          compress: true
        });

        const imgProps = pdf.getImageProperties(dataUrl);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        pdf.addImage(dataUrl, 'PNG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');
        pdf.save(`Invoice-${order_uid}.pdf`);
      })
      .catch(error => {
        console.error('Error generating invoice:', error);
        toast.error('Error generating invoice. Please try again.');
      });
  };

  const printInvoice = () => {
    const invoiceElement = document.getElementById('myInvoice');
    const computedStyle = window.getComputedStyle(invoiceElement);
    const actualWidth = invoiceElement.offsetWidth;
    const actualHeight = invoiceElement.offsetHeight;

    const options = {
      scale: 2,
      height: actualHeight,
      style: {
        transform: 'scale(1)',
        transformOrigin: 'top left',
        padding: computedStyle.padding,
        backgroundColor: 'white',

      },
      quality: 1.0,
      cacheBust: true
    };

    htmlToImage.toPng(invoiceElement, options)
      .then(async (dataUrl) => {
        const pdf = new jsPDF({
          orientation: 'p',
          unit: 'pt',
          format: 'a4',
          compress: true
        });

        const imgProps = pdf.getImageProperties(dataUrl);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        pdf.addImage(dataUrl, 'PNG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');

        const title = `Invoice-${order_uid}`;
        const printWindow = window.open(pdf.output('bloburl'), '_blank');
        if (printWindow) {
          printWindow.document.title = title;
          printWindow.print();
        }
      })
      .catch(error => {
        console.error('Error generating invoice:', error);
        toast.error('Error generating invoice. Please try again.');
      });
  };

  return (
    <>
      {
        loading ?
          <div style={{ height: "70vh" }}>
            <OverlayLoader />
          </div>
          :
          <main style={{ marginTop: "-10px" }}>
            <div className="page-header">
              <div className="container d-flex flex-column align-items-center">
                <nav aria-label="breadcrumb" className="breadcrumb-nav">
                  <div className="container">
                    <ol className="breadcrumb" dir={dir}>
                      <li className="breadcrumb-item">
                        <NavLink to={"/"}>{t("home")}</NavLink>
                      </li>
                      <li className="breadcrumb-item">
                        <NavLink to={`/MyAccount`}>{t("my_account")}</NavLink>
                      </li>
                      <li className="breadcrumb-item">
                        <NavLink to={`/MyAccount/Orders`}>{t("orders")}</NavLink>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        {t("order_details")}
                      </li>
                    </ol>
                  </div>
                </nav>
                <h1>{t("order_details")}</h1>
              </div>
            </div>
            <div className="container account-container custom-account-container" dir={dir}>
              <div className="row justify-content-center">
                <AccountSiderBar />
                <div className="col-lg-10 order-lg-last order-1 tab-content">
                  <div
                    className="tab-pane fade show active"
                    id="address"
                    role="tabpanel">
                    <div className="order-content">
                      <div className="row">
                        <div className="col-md-6">
                          <h3 className="account-sub-title d-none d-md-block">
                            <i className="sicon-social-dropbox align-middle mr-3" />

                            {t("order_number", { value: ":" + order_uid })}
                          </h3>
                        </div>

                        <div className="col-md-6 align-bottom d-flex justify-content-end">
                          <div className="align-bottom d-flex justify-content-end" style={{ paddingTop: '10px' }}>
                            <span style={{ cursor: 'pointer' }} className={`nav-link`} onClick={downloadInvoice}><i className="sicon-cloud-download"></i> {t("Download Order Details")}</span>
                            <span style={{ cursor: 'pointer' }} className={`nav-link`} onClick={printInvoice}><i className="sicon-printer"></i> {t("Print Order Details")}</span>
                            {/* <span style={{ cursor: 'pointer' }} className={`nav-link`} onClick={handleMailInvoice}><i className="sicon-envelope"></i> {t("mail_invoice")}</span> */}
                          </div>
                        </div>

                      </div>

                      <div id="myInvoice">
                        <Invoice
                          order_uid={order_uid}
                          order={details}
                          items={items}
                          address={address}
                          returnData={returnData}
                          cancelData={cancelData}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
      }
    </>
  );

}

export default OrderPrintDownload;
